export default {
  GET_BILLING_REQUEST: "GET_BILLING_REQUEST",
  GET_BILLING_SUCCESS: "GET_BILLING_SUCCESS",
  GET_BILLING_FAIL: "GET_BILLING_FAIL",
};
